import React from 'react';
import { Box, Typography } from '@mui/material';

// 메인화면 역할별 구성 1단계(2026-10-23) - 위젯 하나가 렌더링 중 에러를 던져도 나머지 카드는
// 그대로 보이게 한다. 이 앱에 ErrorBoundary가 처음 들어오는 지점이다(기존 코드에 없었음).
// 서버가 403을 주는 경우(권한과 레이아웃이 어긋난 상태)는 여기까지 오지 않는다 -
// GenericWidgetContainer가 403을 "카드를 아예 숨긴다"로 처리하므로, 이 바운더리는
// 그 외의 예상 못한 렌더링 오류(네트워크 끊김, 알 수 없는 응답 모양 등)만 받는다.
class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[home widget error]', this.props.widgetCd, error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ px: 2, py: 2 }}>
          <Typography variant="body2" color="text.secondary">
            이 카드를 표시하는 중 문제가 발생했습니다.
          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default WidgetErrorBoundary;
